import type { FC } from "react";

import BriefcaseIcon from "@uui/Briefcase01";
import TypeSquareIcon from "@uui/TypeSquare";
import UserCircleIcon from "@uui/UserCircle";

import type { SvgIconProps } from "@mui/material";

import type { CustomVocabularyType } from "@app/analytics/types";

export interface CustomVocabularyTypeConfig {
  Icon: FC<SvgIconProps>;
  label: string;
  value: CustomVocabularyType;
}

export const CUSTOM_VOCABULARY_TYPE_CONFIG: Record<
  CustomVocabularyType,
  CustomVocabularyTypeConfig
> = {
  jargon: {
    Icon: TypeSquareIcon,
    label: "Jargon",
    value: "jargon",
  },
  person_name: {
    Icon: UserCircleIcon,
    label: "Person's name",
    value: "person_name",
  },
  product_name: {
    Icon: BriefcaseIcon,
    label: "Product name",
    value: "product_name",
  },
};

export const CUSTOM_VOCABULARY_TYPES = Object.values(
  CUSTOM_VOCABULARY_TYPE_CONFIG
);
